import { Controller } from "@hotwired/stimulus";
import * as bootstrap from "bootstrap";

export default class extends Controller {
  connect() {
    this.modal = new bootstrap.Modal(this.element.querySelector('#confirmationModal'));
    this.form = null;
  }

  disconnect() {

  }

  showModal(event) {
    event.preventDefault(); // Prevent form submission or link navigation
    this.form = event.currentTarget.closest('form');
    this.modal.show();
  }

  confirm() {
    if (!this.form) return;

    this.modal.hide();
    // Perform the action, e.g., form submission
    this.form.submit();
  }
}
